var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoteIcon = function SvgNoteIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8 7.44772 8.44772 7 9 7H33C33.5523 7 34 7.44772 34 8V24C34 28.9706 29.9706 33 25 33H9C8.44772 33 8 32.5523 8 32V8Z",
    fill: "#FFDF8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4167 27.416C26.4167 26.3114 27.3121 25.416 28.4167 25.416H34V25.416C34 29.6042 30.6048 32.9993 26.4167 32.9993V32.9993V27.416Z",
    fill: "#FFC225"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3333,
    y: 11.334,
    width: 6.5,
    height: 1.625,
    rx: 0.8125,
    fill: "#7E7E7E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3333,
    y: 14.584,
    width: 9.75,
    height: 1.625,
    rx: 0.8125,
    fill: "#7E7E7E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9167,
    y: 11.334,
    width: 9.75,
    height: 1.625,
    rx: 0.8125,
    fill: "#7E7E7E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1667,
    y: 14.584,
    width: 4.33333,
    height: 1.625,
    rx: 0.8125,
    fill: "#7E7E7E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 36,
    rx: 13,
    ry: 1,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoteIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "note-icon.b3c152c72a700c9161175e467b57efd5.svg";